module.exports = __webpack_public_path__ + "012.086b0ea9.png";